import React, {Component} from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar'; 
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import InventoryIcon from '@mui/icons-material/Inventory';
import { apipostfile } from '../../ajax/apirequest';
import ProgressDialog from '../dialogs/ProgressDialog';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import FTextField from '../formfields/FTextField';
import LoginReset from './LoginReset';
import { TextField, MenuItem, Grid, Divider, Box } from '@mui/material';
import PhoneInput from 'react-phone-input-2';

const styles = (theme:Theme):any => ({
  formbox: {
    backgroundColor:'#FFFFFF',
    borderRadius:'15px',
    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
    margin: 'auto',
    maxWidth: 700,
    padding: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      maxWidth: '98vw',
    },
  },
  loginbar: {
    borderRadius:'15px 15px 0 0',
    background: `linear-gradient(90deg, ${theme.palette.primary.main} 60%, ${theme.palette.secondary.main} 100%)`,
    boxShadow: 'none',
  },
  loginform: {
    padding: theme.spacing(2),
    width: '100%',
  },
  xtoolbar: {
    display: "flex",
    justifyContent: "center",
    gap: 10,
    minHeight: 60,
  },
  titlebar: {
    textAlign: 'center',
    margin: theme.spacing(2, 0),
    fontWeight: 700,
    color: theme.palette.primary.dark,
  },
  actionbox: {
    display: "flex",
    justifyContent: "center",
    gap: 10,
    marginTop: theme.spacing(2),
  },
  action: {
    margin: 'auto 5px',
    minWidth: 120,
    fontWeight: 600,
    fontSize: '1rem',
    borderRadius: 8,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  logo: {
    cursor: 'pointer',
    fontSize: 32,
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightLight,
    backgroundImage: 'url(lib/img/logo.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: '0 50%',
    backgroundColor: 'transparent',
    paddingLeft: 5,
    paddingRight: 5,
    height: 40,
    width: 40,
    [theme.breakpoints.down('sm')]:{
      display:'none',
    },
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  selectField: {
    marginBottom: theme.spacing(2),
  },
  splitGrid: {
    [theme.breakpoints.up('sm')]: {
      minHeight: 320,
    },
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(0),
    },
  },
  leftPane: {
    flex: 1,
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      marginBottom: theme.spacing(2),
    },
    borderRight: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('sm')]: {
      borderRight: 'none',
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  rightPane: {
    flex: 1,
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
  },
});

class LoginForm extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);

    this.state = {
      loading: false,
      valid: false,
      data: { cti: 1,idi:0},
    };
  }

  startLoading = () => {
    this.setState({loading:true});
  };

  stopLoading = () => {
    this.setState({loading:false});
  };

  setValid = (data:any) => {
    const param = [
      {id:'unm',req:1},
     // {id:'eml',req:1},
      // {id:'mbn',req:0},
      // {id:'idn',req:0},
      // {id:'idi',req:0},
      {id:'pnm',req:1},
    ];

    const valid = param.every(p => data[p.id]);
    this.setState({valid});
  }

  setPhoneValid = (data:any)=>{
    const phoneValid = /^\d{7,}$/.test(data.mbn || '');
    this.setState({phoneValid});
  }

  setEmailValid = (data:any)=>{
    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.eml || '');
    this.setState({emailValid});
  }

  onChange = (name:string) => (value:any) => {
    const {data} = this.state;
    const newdata = {...data,[name]:value};
    this.setValid(newdata);
    this.setState({ data: newdata });
  }

  onPhoneChange = (name:string) => (value:any) => {
    const {data} = this.state;
    const newdata = {...data,[name]:value};
    this.setPhoneValid(newdata);
    this.setState({ data: newdata });
  }

  onEmailChange = (name:string) => (value:any) => {
    const {data} = this.state;
    const newdata = {...data,[name]:value};
    this.setEmailValid(newdata);
    this.setState({ data: newdata });
  }

  onClick = async() => {
    //console.log('Submitting form data ',this.state.data);
    try{
      
      const formid = window.location.pathname.split('/').pop();
      const {data,}  = this.state;
      var json = {...data,formno:formid,apikey:'55eda0e7-60c7-45f5-95b3-8fc671a16b08',apicode:'apicode'};
      console.log('Submitting form json ',json);
      this.startLoading();
      
      if(!formid){
        this.onError('warn','Form Error','Invalid form identifier');
        return;
      }
      
      const url = `/forms/act/${formid}`
      const response = await apipostfile(url,'',json,formid,'pdf','application/pdf');

      // if(!response){
      //  alert(`${response?.message||'Form request failed'}`);
      //  return;
      // }
      // if (response && response.type === 'application/pdf') {
        
      // }
      const uri = window.URL.createObjectURL(response);
        // Show a download link or open in new tab
        //window.open(url, '_blank'); // To view
        // Or to download:
        const link = document.createElement('a');
        link.href = uri;
        link.download = `${formid}.pdf`;
        document.body.appendChild(link);
        link.click();
        
        document.body.removeChild(link);
        setTimeout(()=>{
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
        }, 100);
      // handle response...
      // window.location.reload();
      this.state = {
        data: { cti: 1,idi:0},
      }
    }
    catch(err){
      const error:any = err || {};
      console.log('Login error:',error.message);
      alert(`Form request failed: ${error.message||'Unknown error'}`);
      //this.onError('warn','Login Error',error.message || "request failed");
    }
    finally{
      this.setState({loading:false});
    }
  };

  onError = (type:string,title:string,message:string) => {
    const {onMessage} = this.props;
    if(typeof onMessage === 'function') onMessage(type,title,message);
    else console.log('onMessage not a function... exiting...',(typeof onMessage));
  }


  render() {
    const {classes} = this.props;
    const {loading,valid,data={},reset, emailValid = true, phoneValid = true} = this.state;
    const logosrc = '/api/logo/mof.png';

    // Dropdown options
    const {idtypes,customertypes} = this.props.data

    return (
      <Paper elevation={6} className={classes.formbox}>
        <AppBar position="static" className={classes.loginbar}>
          <Toolbar className={classes.xtoolbar}>
            <div className={classes.logo} style={{backgroundImage: `url(${logosrc})`}}/>
            <Typography variant="h5" className={classes.titlebar}>
              NTR Revenue Monitoring
            </Typography>
          </Toolbar>
        </AppBar>

        <Typography variant="h4" className={classes.titlebar}>
          Generate a Form
        </Typography>

        <Divider className={classes.divider} />

        <form id="generateform" className={classes.loginform} autoComplete="off">
          <ProgressDialog  
            open={loading} 
            loading={loading}
            startLoading={this.startLoading}
            stopLoading={this.stopLoading}
          />
          <LoginReset
            open={reset}
            onClose={()=>this.setState({reset:false})}
            showNotification={this.onError}
          />

          <Box className={classes.splitGrid}>
            {/* Left: Client Details */}
            <Box className={classes.leftPane}>
              <Typography variant="subtitle1" gutterBottom>
                Client Details
              </Typography>
              <FormControl fullWidth className={classes.selectField}>
                <TextField
                  select
                  label="Client Type"
                  id="cti"
                  value={data.cti || 1}
                  onChange={e => this.onChange('cti')(e.target.value)}
                  variant="outlined"
                  required
                >
                  {typeof customertypes === 'object' && customertypes.map((option:any) => (
                    <MenuItem key={option.rid} value={option.rid}>
                      {option.nam}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>
              <FTextField
                id={'unm'}
                label={'Client Name'}
                value={data.unm || ''}
                onChange={this.onChange('unm')}
                required={true}
                options={{
                  helperText:'Enter client name',
                  InputProps:{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon />
                      </InputAdornment>
                    )
                  },
                }}
              />
              {/* <FTextField
                id={'mbn'}
                label={'Phone Number'}
                value={data.mbn || ''}
                onChange={this.onPhoneChange('mbn')}
                placeholder={'e.g. 233470012346'}
                required={false}
                options={{
                  helperText: phoneValid ? 'Enter phone number' : 'Phone number must be digits only (min 7)',
                  error: !phoneValid,
                  InputProps:{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PhoneIcon />
                      </InputAdornment>
                    )
                  },
                }}
              /> */}
              <PhoneInput country={'gh'}
                value={data.mbn || ''}
                onChange={this.onPhoneChange('mbn')}/>
              <FTextField
                id={'eml'}
                label={'Email'}
                value={data.eml || ''}
                onChange={this.onEmailChange('eml')}
                required={false}
                options={{
                  helperText: emailValid ? 'Enter email address' : 'Enter a valid email address',
                  error: !emailValid,
                  InputProps:{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    )
                  },
                }}
              />
            </Box>
            {/* Right: Company & Product */}
            <Box className={classes.rightPane}>
              <Typography variant="subtitle1" gutterBottom>
                ID & Product
              </Typography>
              <Typography variant="subtitle1" gutterBottom>
                Identification Type
              </Typography>
              <FormControl fullWidth className={classes.selectField}>
                <TextField
                  select
                  label="ID Type"
                  id="idi"
                  value={data.idi || 0}
                  onChange={e => this.onChange('idi')(e.target.value)}
                  variant="outlined"
                  required={false}
                >
                  {typeof idtypes === 'object' && idtypes.map((option:any) => (
                    <MenuItem key={option.rid} value={option.rid}>
                      {option.nam}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>
              {
                data.idi > 0 && (
                  <FTextField
                id={'idn'}
                label={'ID Number'}
                value={data.idn || ''}
                onChange={this.onChange('idn')}
                required={false}
                options={{
                  helperText:'Enter id number',
                  InputProps:{
                    startAdornment: (
                      <InputAdornment position="start">
                        <BusinessIcon />
                      </InputAdornment>
                    )
                  },
                }}
              />
                )
              }
              <FTextField
                id={'pnm'}
                label={'Product Name'}
                value={data.pnm || ''}
                onChange={this.onChange('pnm')}
                required={true}
                options={{
                  helperText:'Enter product name',
                  InputProps:{
                    startAdornment: (
                      <InputAdornment position="start">
                        <InventoryIcon />
                      </InputAdornment>
                    )
                  },
                }}
              />
            </Box>
          </Box>
          <div className={classes.actionbox}>
            <Button
              variant="contained"
              color="primary"
              className={classes.actionx}
              disabled={!valid}
              onClick={this.onClick}
            >
              Submit
            </Button>
          </div>
        </form>
      </Paper>
    );
  }
}

export default withStyles(styles, { withTheme: true })(LoginForm);